<template>
    <div :class="classes" />
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import { BannerQaStatus, BannerQaUserStatus } from "@/enums/banners";

export default defineComponent({
    props: {
        status: {
            type: String as PropType<
                | (typeof BannerQaStatus)[keyof typeof BannerQaStatus]
                | (typeof BannerQaUserStatus)[keyof typeof BannerQaUserStatus]
                | "all"
            >,
            default: BannerQaStatus.Draft
        }
    },
    computed: {
        classes() {
            const classes = ["qa-status-dot"];

            switch (this.status) {
                case BannerQaStatus.Approved:
                case BannerQaUserStatus.IApproved: {
                    classes.push("qa-status-dot--approved");
                    break;
                }

                case BannerQaStatus.InReview: {
                    classes.push("qa-status-dot--in-review");
                    break;
                }

                case BannerQaStatus.Rejected:
                case BannerQaUserStatus.IRejected: {
                    classes.push("qa-status-dot--rejected");
                    break;
                }

                default: {
                    classes.push("qa-status-dot--draft");
                }
            }

            return classes;
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

$status-dot-size: 10px;

.qa-status-dot {
    display: inline-block;
    border-radius: 100%;
    height: $status-dot-size;
    width: $status-dot-size;
}

.qa-status-dot--approved {
    background: $success-color;
}

.qa-status-dot--in-review {
    background: $warning-color;
}

.qa-status-dot--rejected {
    background: $error-color;
}

.qa-status-dot--draft {
    background: $white;
    border: 1px solid $grey5;
}
</style>
